import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Home, FolderGit2, Plug, CreditCard, Settings as Cog, Activity, LogOut } from "lucide-react";

const NAV = [
  { to: "/", icon: Home, label: "Home", testid: "global-nav-home", end: true },
  { to: "/projects", icon: FolderGit2, label: "Projects", testid: "global-nav-projects" },
  { to: "/integrations", icon: Plug, label: "Integrations", testid: "global-nav-integrations" },
  { to: "/billing", icon: CreditCard, label: "Billing", testid: "global-nav-billing" },
  { to: "/settings", icon: Cog, label: "Settings", testid: "global-nav-settings" },
];

export default function AppShell({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="h-screen w-full flex overflow-hidden bg-white text-gray-900">
      <nav className="w-14 flex flex-col items-center py-4 border-r border-gray-200 bg-gray-50 flex-shrink-0 z-30">
        <div className="w-8 h-8 rounded-lg bg-black text-white grid place-items-center mb-6">
          <Activity className="w-5 h-5" strokeWidth={2} />
        </div>
        <div className="flex flex-col gap-1.5 flex-1">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={n.testid} title={n.label}
              className={({ isActive }) =>
                `w-10 h-10 grid place-items-center rounded-lg transition-colors ${
                  isActive ? "bg-black text-white" : "text-gray-500 hover:text-gray-900 hover:bg-gray-200/70"
                }`}>
              <n.icon className="w-5 h-5" strokeWidth={1.6} />
            </NavLink>
          ))}
        </div>
        <button data-testid="global-nav-logout" onClick={() => { logout(); navigate("/"); }} title="Sign out"
          className="w-10 h-10 grid place-items-center rounded-lg text-gray-400 hover:text-gray-900 hover:bg-gray-200/70 mb-2">
          <LogOut className="w-5 h-5" strokeWidth={1.6} />
        </button>
        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 text-white grid place-items-center text-xs font-600" title={user?.email}>
          {(user?.name || user?.email || "U").slice(0, 1).toUpperCase()}
        </div>
      </nav>
      <div className="flex-1 min-w-0 flex flex-col overflow-hidden">{children}</div>
    </div>
  );
}
